// extracted by mini-css-extract-plugin
module.exports = {"section":"art_section__1wJnu","content":"art_content__2GYtD","button":"art_button__3U5SD"};